// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"99dcb11f","700":"8f303500","719":"241074df","845":"064d37e6","983":"1fd66d1f"}[chunkId] + ".chunk.js";
};